module.exports = __webpack_public_path__ + "media/images/sp/shop/step-03-5e33341c3e8f4ef0e88fa97b9622ad53.png";